import React, { useState } from "react";

/* ---------- Data ---------- */
const SUBJECTS = [
  "Architectural Design Studio",
  "Building Construction & Technology",
  "History of Architecture",
  "Structural Systems",
  "Urban Planning & Design",
  "Sustainable Architecture",
  "Interior Design",
  "Landscape Architecture",
  "Advanced Architecture Software",
  "Professional Practice & Ethics",
];

const SOFTWARE_OPTIONS = [
  "AutoCAD",
  "Revit (BIM)",
  "SketchUp",
  
  "Rhino + Grasshopper",
  "Lumion",
  "V-Ray / Enscape (Rendering)",
  "ArchiCAD",
  "Adobe Photoshop / InDesign",
];

const DEGREES = [
  "B.Arch",
  "M.Arch",
  "B.Des (Interior / Product)",
  "M.Des",
  "Diploma in Architecture",
  "Other",
];

const MOBILE_CODES = ["+91", "+1", "+44", "+61", "+971", "+65"];

const WHAT_YOU_GET = [
  "Flexible teaching engagements, online or on campus",
  "Access to India's largest architecture student network",
  "Subjects matched to your exact area of expertise",
  "Transparent scheduling and timely payouts",
  "A platform to build your teaching portfolio",
];

/* ---------- Icons ---------- */
const CheckIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" className="tf-check-icon">
    <path
      d="M13 4L6 11.5L3 8.5"
      stroke="#c84b20"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SuccessIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M20 6.5L9 17.5L4 12.5"
      stroke="#DD6B4D"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" className="tf-chevron">
    <path
      d="M4 6L8 10L12 6"
      stroke="#6B645C"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ---------- Internal CSS (single source of truth for all styling) ---------- */
const STYLES = `
  .tf-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ECE8E1;
    padding: 40px 24px;
    font-family: 'Outfit', sans-serif;
    box-sizing: border-box;
  }
  .tf-wrapper * { box-sizing: border-box; }

  .tf-card {
    width: 100%;
    max-width: 1152px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    background: #fff;
  }
  @media (max-width: 767px) {
    .tf-wrapper { padding: 0; }
    .tf-card { flex-direction: column; max-width: 100%; }
  }

  /* ---- Left panel ---- */
  .tf-aside {
    flex: 0 0 45%;
    background: #181110;
    color: #fff;
    padding: 48px 40px;
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 767px) {
    .tf-aside { flex: 1 1 auto; padding: 40px 24px; }
  }

  .tf-badge {
    color: #c84b20;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    margin: 0 0 16px;
  }

  .tf-heading-light {
    font-family: 'Playfair Display', Georgia, serif;
    font-weight: 300;
    color: #fff;
    font-size: clamp(28px, 4vw, 40px);
    line-height: 1.15;
    margin: 0 0 24px;
  }

  .tf-lead {
    color: #C9C2B8;
    font-size: 16px;
    line-height: 1.6;
    margin: 0 0 32px;
  }

  .tf-subtitle {
    color: #c84b20;
    font-weight: 600;
    font-size: 15px;
    margin: 0 0 16px;
  }

  .tf-list {
    list-style: none;
    margin: 0 0 8px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .tf-list-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    color: #EDE9E2;
    font-size: 15px;
  }
  .tf-check-icon { width: 16px; height: 16px; flex-shrink: 0; margin-top: 6px;
  color:#c84b20; }

  .tf-footer {
    margin-top: auto;
    padding-top: 32px;
    border-top: 1px solid rgba(255,255,255,0.1);
  }
  .tf-footer p { color: #B8B1A6; font-size: 14px; margin: 0; }

  /* ---- Right panel / form ---- */
  .tf-main {
    flex: 1 1 auto;
    background: #fff;
    padding: 48px;
  }
  @media (max-width: 767px) {
    .tf-main { padding: 40px 24px; }
  }

  .tf-form-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-weight: 400;
    color: #1E1812;
    font-size: clamp(24px, 3vw, 34px);
    margin: 0 0 28px;
  }

  .tf-form {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .tf-section-label {
    font-weight: 400;
    font-size: 15px;
    color: #1E1812;
    margin: 0 0 12px;
    font-family: "Outfit", sans-serif;
  }

  .tf-row-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }
  @media (max-width: 640px) {
    .tf-row-2 { grid-template-columns: 1fr; }
  }
  .tf-row-2:last-child { margin-bottom: 0; }

  .tf-row-phone {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }
  .tf-code-wrap { width: 110px; flex-shrink: 0; position: relative; }
  .tf-number-wrap { flex: 1 1 auto; }

  /* ---- Fields ---- */
  .tf-field {
    width: 100%;
    background: #E9E4DA;
    padding: 10px 16px;
    font-size: 15px;
    color: #2B2620;
    border: 1px solid transparent;
    outline: none;
    font-family: inherit;
    transition: border-color 150ms, background-color 150ms;
  }
  .tf-field::placeholder { color: #8A8378; }
  .tf-field:focus { border-color: #c84b20; background: #F1EEE6; }
  .tf-field.tf-textarea { resize: none; }

  select.tf-field {
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    padding-right: 36px;
  }
  select.tf-field.tf-placeholder { color: #8A8378; }
  select.tf-field option { color: #2B2620; }

  .tf-select-wrap { position: relative; }
  .tf-chevron {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  /* ---- Nested "software specialization" dropdown ---- */
  .tf-nested {
    margin-bottom: 16px;
    padding-left: 16px;
    border-left: 2px solid #EADFD3;
    animation: tfFadeSlideIn 0.22s ease-out;
  }
  .tf-nested-label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #8A8378;
    margin: 0 0 8px;
  }
  @keyframes tfFadeSlideIn {
    from { opacity: 0; transform: translateY(-6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  /* ---- Submit ---- */
  .tf-submit {
    width: 100%;
    // border-radius: 12px;
    background: #1B140F;
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    padding: 14px 0;
    border: none;
    cursor: pointer;
    transition: background-color 150ms;
  }
  .tf-submit:hover { background: #2A211A; }
  .tf-submit:active { background: #120D09; }
  .tf-submit:disabled { opacity: 0.65; cursor: not-allowed; }

  /* ---- Validation ---- */
  .tf-field.tf-invalid {
    border-color: #D64545;
    background: #FBEDEC;
  }
  .tf-error-msg {
    display: block;
    color: #D64545;
    font-size: 12.5px;
    margin-top: 6px;
    line-height: 1.4;
  }
  .tf-submit-error {
    color: #D64545;
    font-size: 14px;
    margin: -16px 0 0;
    text-align: center;
  }

  /* ---- Success Popup ---- */
  .tf-popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(24, 17, 16, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    z-index: 1000;
    animation: tfOverlayFade 0.2s ease-out;
  }
  @keyframes tfOverlayFade {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .tf-popup-card {
    background: #fff;
    max-width: 420px;
    width: 100%;
    padding: 40px 32px;
    text-align: center;
    box-shadow: 0 30px 80px -20px rgba(0,0,0,0.4);
    animation: tfPopupIn 0.25s ease-out;
  }
  @keyframes tfPopupIn {
    from { opacity: 0; transform: translateY(12px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  .tf-popup-icon-wrap {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;
    border-radius: 50%;
    background: #FBEAE3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tf-popup-icon-wrap svg { width: 28px; height: 28px; }
  .tf-popup-title {
    font-family: 'Lora', Georgia, serif;
    font-weight: 600;
    color: #1E1812;
    font-size: 22px;
    margin: 0 0 10px;
  }
  .tf-popup-text {
    color: #6B645C;
    font-size: 14.5px;
    line-height: 1.6;
    margin: 0 0 28px;
  }
  .tf-popup-close {
    width: 100%;
    border-radius: 12px;
    background: #1B140F;
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    padding: 14px 0;
    border: none;
    cursor: pointer;
    transition: background-color 150ms;
  }
  .tf-popup-close:hover { background: #2A211A; }
`;

const namePattern = /^[A-Za-z\s.'-]+$/;

/* ---------- Component ---------- */
export default function TrainerApplicationForm() {
 
  const [formData, setFormData] = useState({
  firstName: "",
  email: "",
  mobileCode: "+91",
  mobile: "",
  subject: "",
  software: "",
  experience: "",
  degree: "",
  portfolio: "",
  message: ""
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => {
    let updated = { ...prev, [name]: value };

    if (name === "subject" && value !== "Advanced Architecture Software") {
      updated.software = "";
    }

    return updated;
  });

  if (name === "firstName" && value.trim() && !namePattern.test(value)) {
    setErrors(prev => ({ ...prev, firstName: "Name can contain letters only." }));
  }

  // clear the field's error as soon as the person starts fixing it
  if (errors[name] && !(name === "firstName" && value.trim() && !namePattern.test(value))) {
    setErrors(prev => {
      const next = { ...prev };
      delete next[name];
      return next;
    });
  }
};

  const validate = (data) => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-./?%&=]*)?$/i;

    if (!data.firstName.trim()) {
      newErrors.firstName = "Please enter your full name.";
    } else if (!namePattern.test(data.firstName.trim())) {
      newErrors.firstName = "Name can contain letters only.";
    }

    if (!data.email.trim()) {
      newErrors.email = "Please enter your email ID.";
    } else if (!emailRegex.test(data.email.trim())) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!data.mobile.trim()) {
      newErrors.mobile = "Please enter your mobile number.";
    } else if (!/^\d{7,12}$/.test(data.mobile.trim())) {
      newErrors.mobile = "Please enter a valid mobile number.";
    }

    if (!data.subject) {
      newErrors.subject = "Please select a subject to teach.";
    }

    if (data.subject === "Advanced Architecture Software" && !data.software) {
      newErrors.software = "Please select your software specialization.";
    }

    if (!data.experience.toString().trim()) {
      newErrors.experience = "Please enter your years of experience.";
    }

    if (!data.degree) {
      newErrors.degree = "Please select your degree.";
    }

    if (!data.portfolio.trim()) {
      newErrors.portfolio = "Please enter your portfolio / LinkedIn URL.";
    } else if (!urlRegex.test(data.portfolio.trim())) {
      newErrors.portfolio = "Please enter a valid URL.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");

    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/workAtIPDIfunction/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      if (!res.ok) {
        throw new Error("Submission failed");
      }

      const data = await res.json();
      console.log(data);

      setFormData({
        firstName: "",
        email: "",
        mobileCode: "+91",
        mobile: "",
        subject: "",
        software: "",
        experience: "",
        degree: "",
        portfolio: "",
        message: ""
      });
      setErrors({});
      setShowSuccess(true);
    } catch (err) {
      console.error(err);
      setSubmitError("Something went wrong while submitting. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const fieldClass = (name) =>
    `tf-field${errors[name] ? " tf-invalid" : ""}`;

  const showSoftwareDropdown = formData.subject === "Advanced Architecture Software";

  return (
    <div className="tf-wrapper">
      <style>{STYLES}</style>

      <div className="tf-card">
        {/* ================= LEFT PANEL ================= */}
        <aside className="tf-aside">
          <div>
            <p className="tf-badge">Join our Faculty</p>
            <h1 className="tf-heading-light">
              Teach the architects of tomorrow.
            </h1>
            <p className="tf-lead">
              We connect experienced practitioners and educators with
              architecture &amp; design students across India — bringing
              real industry expertise straight into the classroom.
            </p>

            <h2 className="tf-subtitle">What you get</h2>
            <ul className="tf-list">
              {WHAT_YOU_GET.map((item) => (
                <li key={item} className="tf-list-item">
                  <CheckIcon />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="tf-footer">
            <p>120+ trainers already shaping careers with us</p>
          </div>
        </aside>

        {/* ================= RIGHT PANEL / FORM ================= */}
        <main className="tf-main">
          <p className="tf-badge">Trainer Application</p>
          <h2 className="tf-form-title">Apply to Become an IPDI Trainer</h2>

          <form onSubmit={handleSubmit} className="tf-form">
            {/* ---------- Personal Details ---------- */}
            <section>
              <h3 className="tf-section-label">Personal Details</h3>

              <div className="tf-row-2">
                <div>
                  <input type="text" value={formData.firstName} name="firstName" onChange={handleChange} placeholder="Full name *" className={fieldClass("firstName")} />
                  {errors.firstName && <span className="tf-error-msg">{errors.firstName}</span>}
                </div>
                <div>
                  <input type="email" value={formData.email} name="email" onChange={handleChange} placeholder="Email ID *" className={fieldClass("email")} />
                  {errors.email && <span className="tf-error-msg">{errors.email}</span>}
                </div>
              </div>

              <div className="tf-row-phone">
                <div className="tf-code-wrap">
                  <select defaultValue="+91" className="tf-field" value={formData.mobileCode} name="mobileCode" onChange={handleChange}>
                    {MOBILE_CODES.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                  <ChevronIcon />
                </div>
                <div className="tf-number-wrap">
                  <input type="tel" value={formData.mobile} name="mobile" onChange={handleChange} placeholder="Mobile number *" className={fieldClass("mobile")} />
                  {errors.mobile && <span className="tf-error-msg">{errors.mobile}</span>}
                </div>
              </div>
            </section>

            {/* ---------- Teaching Details ---------- */}
            <section>
              <h3 className="tf-section-label">Teaching Details</h3>

              <div className="tf-row-2">
                <div>
                  <div className="tf-select-wrap">
                    <select
                      value={formData.subject}
                      name="subject"
                      onChange={handleChange}
                      className={`${fieldClass("subject")}${formData.subject ? "" : " tf-placeholder"}`}
                    >
                      <option value="" disabled>Select subject to teach *</option>
                      {SUBJECTS.map((s) => (
                        <option key={s} value={s}>{s}</option>
                      ))}
                    </select>
                    <ChevronIcon />
                  </div>
                  {errors.subject && <span className="tf-error-msg">{errors.subject}</span>}
                </div>
                <div>
                  <input type="number" min="0" value={formData.experience} name="experience" onChange={handleChange} placeholder="Years of experience *" className={fieldClass("experience")} />
                  {errors.experience && <span className="tf-error-msg">{errors.experience}</span>}
                </div>
              </div>

              {/* Nested dropdown — shows only when "Advanced Architecture
                  Software" is picked above. Indented, with margin below it
                  (tf-row-2 that follows) for clear spacing. */}
              {showSoftwareDropdown && (
                <div className="tf-nested">
                  <label className="tf-nested-label">
                    Advanced Architecture Software — Specialization
                  </label>
                  <div className="tf-select-wrap">
                    <select
                      value={formData.software}
                      name="software"
                      onChange={handleChange}
                      className={`${fieldClass("software")}${formData.software ? "" : " tf-placeholder"}`}
                    >
                      <option value="" disabled>Select software specialization *</option>
                      {SOFTWARE_OPTIONS.map((s) => (
                        <option key={s} value={s}>{s}</option>
                      ))}
                    </select>
                    <ChevronIcon />
                  </div>
                  {errors.software && <span className="tf-error-msg">{errors.software}</span>}
                </div>
              )}

              <div className="tf-row-2">
                <div>
                  <div className="tf-select-wrap">
                    <select
                      value={formData.degree}
                      name="degree"
                      onChange={handleChange}
                      className={`${fieldClass("degree")}${formData.degree ? "" : " tf-placeholder"}`}
                    >
                      <option value="" disabled>Select degree *</option>
                      {DEGREES.map((d) => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>
                    <ChevronIcon />
                  </div>
                  {errors.degree && <span className="tf-error-msg">{errors.degree}</span>}
                </div>
                <div>
                  <input type="text" placeholder="Portfolio / LinkedIn URL *" value={formData.portfolio} name="portfolio" onChange={handleChange} className={fieldClass("portfolio")} />
                  {errors.portfolio && <span className="tf-error-msg">{errors.portfolio}</span>}
                </div>
              </div>
            </section>

            <textarea
              rows={4}
              value={formData.message} name="message" onChange={handleChange}
              placeholder="Tell us a bit about yourself (optional)"
              className="tf-field tf-textarea"
            />

            {submitError && <p className="tf-submit-error">{submitError}</p>}

            <button type="submit" className="tf-submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit Application"}
            </button>
          </form>
        </main>
      </div>

      {showSuccess && (
        <div className="tf-popup-overlay" onClick={() => setShowSuccess(false)}>
          <div className="tf-popup-card" onClick={(e) => e.stopPropagation()}>
            <div className="tf-popup-icon-wrap">
              <SuccessIcon />
            </div>
            <h3 className="tf-popup-title">Application Submitted!</h3>
            <p className="tf-popup-text">
              Thanks for applying to become an IPDI trainer. Our team will
              review your application and get in touch with you soon.
            </p>
            <button className="tf-popup-close" onClick={() => setShowSuccess(false)}>
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
}